import { render, staticRenderFns } from "./MockupImageWrapper.vue?vue&type=template&id=7f33996a&scoped=true&"
import script from "./MockupImageWrapper.vue?vue&type=script&lang=js&"
export * from "./MockupImageWrapper.vue?vue&type=script&lang=js&"
import style0 from "./MockupImageWrapper.vue?vue&type=style&index=0&id=7f33996a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f33996a",
  null
  
)

export default component.exports